import { getStylesFn } from 'core/helpers/styles'
import { ElementVideoOptions } from 'core/types/element/element_video'
import optionsPropTypes from 'PropsSpec'

const extractStyles = getStylesFn(['paddingTop', 'paddingRight', 'paddingBottom', 'paddingLeft'])

type Props = {
  options: ElementVideoOptions
}

const Video = (props: Props) => {
  const { options } = props

  const styles = extractStyles(options)

  return (
    <div className="wf_reset wf_video_wrapper" style={styles}>
      <div className="wf_reset wf_video_embed">
        <div className="wf_reset wf_video_padding"></div>
        <div className="wf_reset wf_video" dangerouslySetInnerHTML={{ __html: options.embed_code }}></div>
      </div>
    </div>
  )
}

Video.propTypes = {
  options: optionsPropTypes('video')
}

export default Video
